<template>
    <div id="covered-legislations">
        <h6>
            {{ $t('Component(ReceivedRequestSteps):requested-regulations') }}

        </h6>
        <ul class="p-0">
            <li v-for="legislation in legislations">
                {{ legislation.title }}
                <InstructionInfoButton
                    v-if="legislationTranslationsLoaded && hasTranslations(legislation)"
                    class="pl-1"
                    :instruction="instruction(legislation)"
                    :title="title(legislation)"
                    button-class="btn-icon btn-sm"
                    icon-size="14"
                />
            </li>
        </ul>
    </div>
</template>

<script>
import InstructionInfoButton from "@core/components/common/instructions/InstructionInfoButton";
import legislationTranslations from "@core/mixins/legislation-translations";

export default {
    mixins: [legislationTranslations],
    components: {InstructionInfoButton},
    props: {
        legislations: {
            type: Array,
            default() {
                return [];
            }
        },
    },
    methods: {
        title(legislation) {
            const header = this.getLegislationInfoTranslationHeader(legislation.id);
            return header || this.$t('Component(IButton):legislation-title-' + legislation.key);
        },
        instruction(legislation) {
            const instruction = this.getLegislationInfoTranslation(legislation.id);
            return instruction || this.$t('Component(IButton):legislation-instruction-' + legislation.key);
        },
        hasTranslations(legislation) {
            if (this.hasLegislationInfoTranslation(legislation.id)) {
                return true;
            }
            return this.isTranslationSet('Component(IButton):legislation-title-' + legislation.key)
                || this.isTranslationSet('Component(IButton):legislation-instruction-' + legislation.key);
        },

        isTranslationSet(key) {
            const translation = this.$t(key);

            return translation !== key && translation.length > 0;
        }
    }
}
</script>

<style>
#covered-legislations ul {
    list-style-type: none;
}
</style>
